import * as React from 'react';
import '../../Assets/styles/notification.css';
import { Text as T } from 'ilenia';
// @ts-ignore
import { NotificationContainer, NotificationManager } from 'react-notifications';

export enum NotificationType {
    Success,
    Info,
    Warning,
    Error
}

export class NotificationAlert extends React.Component {
    public static alert(type: NotificationType, body: string, useTransalations: boolean = true, title: string = '', timeout: number = 4200) {
        const textBody = useTransalations ? <T id={body} /> : body;
        const textTitle = useTransalations && title ? <T id={title} /> : title;
        switch (type) {
            case NotificationType.Success:
                NotificationManager.success(textBody, textTitle, timeout);
                break;
            case NotificationType.Info:
                NotificationManager.info(textBody, textTitle, timeout);
                break;
            case NotificationType.Warning:
                NotificationManager.warning(textBody, textTitle, timeout);
                break;
            case NotificationType.Error:
                NotificationManager.error(textBody, textTitle, timeout);
                break;

            default:
        }
    }

    public render() {
        return (
            <NotificationContainer />
        );
    }
}
